export default __webpack_public_path__ + "static/media/trash-outline-purple.269db1d6.svg";